const overviewStockTableHeaders = [
  {
    id: 'posicao',
    group: '#',
    canPrint: true
  },
  {
    id: 'codigo',
    group: 'Código',
    canPrint: true
  },
  {
    id: 'nome',
    group: 'Nome',
    canPrint: true
  },
  {
    id: 'valor',
    group: 'Valor',
    canPrint: true,
    align: 'right'
  }
]

export default overviewStockTableHeaders
